import { capitalize } from 'lodash';
import { dateToLabel } from 'further-ui/utils';
import { loadPdfMake } from './pdfMakeLoader';

const checkImage =
  'data:image/png;base64,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';

const userImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAmpJREFUWIXtl09IVUEUxk9mkorRImwRBgVui1JC4kVCoVQSEVRQq/7QIlpVLoInvp1U0C5aFCS5iDZSpBao5aJlm4oCVy6kKMhKN/3PvsN8l/d8zlxn7hto4wc/eNxzvjPn3Tt3Zq7IshZqBbgDfoJ58rqCeq9K6mjNfo7hVCuTp8AzctORuw7sII2OnBsldaZYuzWtgXYm9Tri2v0J8AL8leK/U16Ck6DK4S0wb3fWBtaAx4z/4O+rZBh8Z2wUrM3aQAuTLpZdXwUmGBsCGy3eDeAhc56DmrL4BcZa0hpQbbOYL9N8H6xM8ertv8fcfFmshrWDtRrMgI9iHsNSagAfwBdQm2XAcnWK+UdXAjx99OyL0UDy7A4FeA7ScylGA3kW2xvg2UNPT4wGTrHY2QDPaXrOxGigWYrvt6+G6WmO0YBqnAUPeOR2iFkln8YaXLUFfANfxayWLu0Cn8WsiluzDLQJfALHLLHDYpbg3+C8JX6OMd31jljiR8WsJ5vTGmiX9M1oP/gFpi2xaca6HN6CVLgZ6cyeYXzQEh9kTB+B7Y3xaiDHJJ10eXIc3OV1baAb1Fm8dYwlTQ7QWyATvJ5La0CLTMrCfT5Bm1qfZqY0Z8xRY9LR/KIm9DbpajZC4yNZvEOmSXOTrXmI9XI+g5dqu5hZ/RbUhxgp9bxhjSXPADbpyqcLys4sZqqNNcZDjbqIJLe+Uj1graDDyDWJt58n54nrISb9FpiTsInnkp4nZ8XMBy/pTP0jcTeTUdb0msxNYm7ZO/DEgzEP3rOm7TRt1S0xr49tMcmC1rrtO3giPWJXR8L1tfT/9Q/JNcknEvdv7wAAAABJRU5ErkJggg==';

const idImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAARVJREFUWIVjYBgFo2AUIEAaED8E4hc0wk+AuAWfA54C8UwgjqcRbgbif0DMhcsBr4E4EohZgTgTiAvwYC0s+lWAeAsQn0DCx4F4OhCzAbEZEP8HYn5CDhAH4jNAfBkPTsGifwYQXwLiejT8A4h9SHEACHAAMQ8SZsWlCQksAeKFWMTfAnE4KQ6QBeLfUMUwfI2eDgABEyC2RsKq9HYAOWDAHTAbiM8BcQka/g7EfvRwgCYQH2BAzS2gXLGYAZKoae4AQoAkB4AUiVAJC5HqAFA2/MuAmg0pxU6khgAoPvWphPWAmIlUB9ACEHQAqPy/x4BamVATg0rTN0DMgssB8kBcBsTVNMKVQKxLMJxGwSgYBaOA3gAAMJqqOgq7jxAAAAAASUVORK5CYII=';

const faceImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAU9JREFUWIXtl09OwkAUxgcSNqxkAbJWJBFCN7BFdOEFFNbCCeAaJECklyAQjKeCU2Dwe/F1UzqvM5WxTeRLfknTvj9fp53OVKmLTuWBQQQ1ixp3mhpeXOICHDW8WxhYCnXmuiSPA95AzqKZqajmkHu0ogIGfNFF80B57tGXDLjWkXtdDGTPAM1zm6mWVF/gJUliDxQN4oocq9ODYZ0TmTp/BYckDeKkfXYhOXuX9uDRIO4J7FwYCKsD2n/RSKdghUtNNNTjNA3QwrICE3DtulmJiTJBI1EJnb9izqZb8AEKBrEU8wlubJvQNmopXKc73YCyEEMjQUafhRhfabZ3Jh+QOliDKeiCKtPlc1twH1PjLKthQ/28fD5Dx03D3Owux5kxkNqmNNiWDznQRfORErblpLnS/1BIUzQsX6gzi0smdzREv/k1q0Xk95Vw5/9X33YqXen6FEnOAAAAAElFTkSuQmCC';

const eyeImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAjxJREFUWIXtlc1LlUEUxs9VM9GgIBASV7ZJC5KIMr82dWlntEz8WBQluAjddDcmRoSiKG4KxBYtJAPBgor6C1JqIaER1UJFVCr7QCKMtJ6Hcy7cXucdPzIweB/4weXOmfc5c2bmjEikSJH+Q6WBQnAWXAIXwRlQ8C9Nd5jhXbAAfoUwCbpB0VYZ7wJXwKwZjIFrIA72gXQjH1SBm+A9WAEPwZG/Ma8x4x/gNji8znk7QT14A5ZBH9izEWMGD4uu+D7Y74g5CgbAW/AODIKSQAy3rQksgmlQsR5zlnUcfAXnQmIawE/RFfaI7vlr0dVedsTzcD4TreQFn3m26B6z7IdCYo6Z+S2QkfI/z0GvJVHumJcpuo08G41hCdwA30GxJ8l7oqvNcIzxer4U3TaXYilJxl2Teb26PObUJOj0jF8Hc55x+jwR3b5Y6gCvm7c8pinQ4RnnFZ1f4xvN5rXqZgyBD+CAZzJvB8uc5hjjil6AR575J8E30O8a3AteiTaSspAPVIpm3y5/lpC/20Sv7qr9NbFlL4luQVZYhrlgRPTKJERPd1AJS4KrbQUtYNTMWx3xXNigjfMmZIaZJ8VOljytz8EJRwxL+Rh8FD28T8HpQAyTPy9a0c+gbi3joNi52Be42gcSvi1BsQNWgwmbywcsb6PmSXEVNfYxlpBd8iooBTkpcbvBKdHOOGfGrNDxzRoHxUPGst8BnywZmnwxks/xjCVxcKuMXWIX5DPLFy9h1JppzDMvUqRI21O/AXpbf9KTh5EDAAAAAElFTkSuQmCC';

const nameImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAP9JREFUWIVjYBgFo2AQglU0xgTBfxrjAXXAP2IcMApGAbkJjKgsRk8H5APxMyCuJ9UB5BYwhUhmCADxV6jDfgKxOKmOoBTkMqCGTiW9HXAFzQH3gJiJWM3kBDkysEGy+BcS24NYB1Ca6hcjqUGOivXUdsBKLHqFgfg7VP4KVOwElP8biKWJdQS5oIgB1fcgkIgkVkdLyxmB+AaSZTsYING0BUnsERAzEzIolADGBRwZiIs6X0IOILdBsYJIB2yhhQNEGSAlHkj+PA41h6Hyf4BYDp8D8AV/CA49OkgOTMehJhpJjSk+B5ALIhggKZ8FhzyoJEwD4ihaWD4KRgHZAAAhWuR3eEkg+QAAAABJRU5ErkJggg==';

const checkIcon =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAsZJREFUWEftlVtIFFEYx7+ZOdPeht2d2VuYIpVpmhqVgUER1KI+RPRWPvQU+VBE5Q2yQDGjexkWiRD10ktLPRVRqD1IIciiuF56sCjC0hl39tbq7pzdnZggEG+7q64+tOf1+87//+PPOd9HwDofYp39IQ2QTiCdwP+RQOZF0GQZOAdBUtwnl3AAHBD9N39SnsCeKqDpDPMrtVp1JBqN/pj+PrHV2QF4bQCagCwF7rlarTkRi8UEkXcfHGqVRmdP31QmQOxtZNt1Gm1VLCb7PG7hsOsuds4d/SkDKLnC3mIYbZ0sy9MeUawYvB3qWWjvpASgpMFwmdEzLTLIkuhxH3PdDL9dbOmtOsDuBuasXm94CCBHvV5P5cCNGcdSG3ceQGkT9wJIUjclTFWOtYE/mXW965LupN5gfEYAED6f/3T/9cCTePfnAexvsY0ihLZLYdw7Mc5XfO0AXzwRpV5Urz1m4owOAAL5At6a/mvBe4ncmweQX6PONrHGboSoLZIk9QV+CeWux+BZSqyoVm03mbnXAIQqEAw0O6/6GxMxV3oWfAOF1ZosljN0U4jKwRg7vSJfNnwfxIVEi2rRPs5kfU8QBBP4HXzgbPFeSNR8UQClUFyvydTrDV0IUbkY4wH3BG///Ajcs8V3VNM7TWbLB5Ik2OD0zNO+ZvEUAMirAqCI5NVrMyx6phshOg9jPDjJ8/axNhCUWn6dapuFZXtIkrKFQjMve4fF47NnfKIQcb9hwRnYyGXYuhBCBZEIHhoXeLuO0mxgzYYeiqSyw+HQO5/sPjrSBFKipkmP4s3nwbbJYu1EiC6MRCIjADL1NxVJ+hjwC+WDdyC4HPMl38BcwZxzYLFZrZ00TRcrNYxx/7ibP/StFbzLNU8KQGnOrQGz1Wh9E5NBNfmTL/vSDvxKzJMGWKnZmi2jZEDj/oJkxJbTmwZY9wT+AE1B8iHcPAt9AAAAAElFTkSuQmCC';

const warningIcon =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAABC5JREFUWEfNl19s01UUxz/3127rQBdmRJyJisynolFQMzdfjLoXedKoEyJqjA74dVVHMKjBcgeEgERH6PpjbGqIhmAw6NN4UDG++AcVNqfOF2ZQEyWAYjCWjba/6+7tr0vdOnotarxPTXrO+X7vOed37vcILI90uQjB3SjuABYD84E5gftvwDEEg0LxQWSMA2tf43eb0KKc0cYOrsn5rAUeAmaXsw/+/wPBHny2yp18dz6fGQnsiFPza5YEDmtQVAM54EMBAwoOVVUxmvmJ0zp41RXUZzI0CmhSsGTC7nYghOAc8NIlDl1PJhkvRaQkgU0xrs4q3g5SnQH68dkmezlmkwHjD8+gaNf8gEF87i3lP43AhhgLfcV7QAOKL50QyxM9fGUDPNVGruQ6HN4AbgSO49Mqe/m62O4vBIKbfxKA76+LsHx1N2crAS/4vNxJ7ZlxXgfuC0g0F2dikoCpeQ4NvgjF/ugp2h54y9T9gs+++wmNzOXNgMQQaZrlbsZ04EkCMsZmFM8BQ3U1tNjcXLq0OA4i0cNH5VgGmfg4KMcW6RmsPAG5igU4fItCOA432dZcuqSNv8escgSMXb4njiBQIYfoC0lG8wRi7DIdK0jJFB02wYyfiwoIlJ0nhZjSJQkGo196tIutj3Hx2Qg/A5GwoHFdiu//VQLtXEXYDKfx2jEuF10ubQrTIO9Lj1Zb8EozEPjpz/wuBEtFIf0CVq/36P5PCMR4GmWw+oV0+Ry4GbhNeugutT6V9IAOviFGs68M1heawEngUnzmyV5OWKNX2IQ6/uY4c8/lDNYpTUDP+nBDluoVfea39ak0A8FgyuoH7n9BwJSgOsRlzydNOaxPpRkoKsEvk03oCFoSKfMWWJ9KCchV3IowWIc1gT7gCQSdMsV2a/R8Ex7W41x6RqJZny6XpxRsR/GKngMPothbySCyRpxiOPGIvQu0ClhWGMXHgRqyLJB9/FBpYBs/WTSKCdGQf4wKZYAe6RG3CRT4fRaU4BZrnxg7UAbjVenxuCGwMU5jzmfEPMeCRYkU39gE/Ls9IFcQJcygia1YKD2OFguSLSgjvwdJ01JQLDZEbGzko0SYZYSLbtgXpWewihSRNqjlUwQ3APuiJ1n2D0uyPUAbMEyapmmSzJQiv4To73OeJkGaRy40E8HNdwfgJ1A0Fy8r02V5B9f7vpHlmsQRR/CwbU9MLYWpecjIcp12Dd4qdzJcbFdSSplM5HjHlCO/3ewKK7at8/jRpt6bXK7MwhoEK4Otanhix7in1Jo2o5YzqZuNBDqLVrODCAYcOORnGI2ezq9mI/XUO1U0+tCEMqvZnWY1w7yu3aRZP1Mpy4pJ6XIt8CywdKJ7rdQvGLWsp6uW30fPl7WyBArOMk6dyLFE6fVcsBjBfJRZz7Uyzq/nMCTgoAoxIJOcsSnXn6T6mpRPCBimAAAAAElFTkSuQmCC';

const failIcon =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAo5JREFUWIXt1UtoVFcAxvHf5IFJJjpjBl+xmlFMW1I7CCKi3bjRpi2IVrSgCy1Ig/ZB240UMSAoggsfRIUGRDfaIrRQ3HRhUSQWbE00NvGFD4yGwQRRG21oE3O7UXGRmbkTXQjOf33O9/3PueecS4ECBV5xihZQ9oIZkXmUZyzINnM2c2bQtIzaEZYXrWBBLTtHJICuSlLVNC8hiUge5cWrWTqFpjIeZByULSHNw8m0xFgYZ9lUWi/QE6Z8FYvHs+sRv37PBgzlLQAXuTuO43E+ivHJNP7oyCIxm9IPWD2exj4OXmPbdf7JaBpiNa7QV03LGOaPZmUN7Z2kh8urZ1WCzX9zqJmt1+nPlh1KAC5xv5JjCd6Ls3Y6nX9xCwHMo7yeL6v45h47ztKU5t9cuaEF4Ab9b3AqSirGmiQXOuhCySLWj+Xb++zdz94w5eR3qp+RIjqf7RUsuktjOTMrWd7L5g6OtDIQNiuvHXjKHQZinI6TrOLrUt69x5YDHEozmE9WrncgIyUEQwxFEBAEGa5ZLka0AymiKbZGqe/hu4A7MRpq6S3hcjoPmbwFPmRiil0VzL3F54c5eoYT71BcReNYBtv405Pb8VIF3qdqBrtHMauHr37g5JOioVGcixOMYV0dA2V03A5xHkILfExNkj2lJNOsO8zvnlvlbQZbOf0WfQk2xalopUWOzxFGILKY6ik0lzCpm4YjtBl+i4MBOhM8iNNQx+gJtF/N8ibkFFjKm0n2FRG9yfqfOJ+hHPTy+Czt0+lOsLGCSWc4ZiQ/ozlMnMmPEYqu8ekvXM5W/hzBea68TVectXVUt/HbcAOzvgPF1PRz8SafHeVGyPKnPD7Az9188R+JPOYVKPCa8T8ngLXqrbUm4wAAAABJRU5ErkJggg==';

type CheckDetails = {
  approved?: boolean;
  results?: Array<{
    status?: string;
    recommendation?: string;
    reason?: string;
    breakdown?: Array<{
      subCheck?: string;
      result?: string;
      details?: Array<{
        value?: string;
        name?: string;
        caDocId?: string;
        reasons?: Array<string>;
        countryNames?: Array<string>;
      }>;
    }>;
    watchlistSummary?: {
      totalHits?: number;
      associatedCountryCodes?: Array<string>;
      searchConfig?: {
        clientRef?: string;
        sources?: {
          type?: string;
        };
      };
      rawResults?: Array<Record<string, string | Record<string, string>>>;
    };
  }>;
};

type KycData = {
  createdAt?: string;
  detailsMatch?: boolean;
  documents: Array<{
    documentId?: string | null;
    documentType?: string | null;
    issuingCountry?: string | null;
    extractedDocument?: Record<string, string | Record<string, string>>;
  }>;
  sessionId?: string;
  investorId?: string;
  yotiStatus?: string;
  livenessCheck?: CheckDetails;
  documentAuthenticityCheck?: CheckDetails;
  faceMatchCheck?: CheckDetails;
  amlCheck?: CheckDetails;
};

const downloadKycPdf = async (
  kycData: KycData,
  kycImages: {
    livenessCapture?: Array<{ content?: string }>;
    documents?: Array<Array<{ content?: string }>>;
  },
  investorDetail?: { fullName?: string },
) => {
  const {
    createdAt,
    detailsMatch,
    documents,
    sessionId,
    investorId,
    livenessCheck,
    documentAuthenticityCheck,
    faceMatchCheck,
    amlCheck,
    yotiStatus,
  } = kycData ?? {};

  const livenessCaptureRows: Array<Array<{ content?: string }>> = [];
  for (let i = 0; i < (kycImages.livenessCapture?.length ?? 0); i += 3) {
    //@ts-expect-error
    livenessCaptureRows.push(kycImages.livenessCapture?.slice(i, i + 3));
  }

  const getWatchlistSummary = (
    checkResults: Array<{
      watchlistSummary?: {
        totalHits?: number;
        associatedCountryCodes?: Array<string>;
        searchConfig?: {
          sources?: { type?: string };
          clientRef?: string;
        };
      };
    }>,
  ) => {
    return (
      checkResults.find((result) => !!result.watchlistSummary)
        ?.watchlistSummary ?? {}
    );
  };

  const getDocumentImageRows = (documentIndex: number) => {
    const documentImageRows: Array<Array<{ content?: string }>> = [];
    for (
      let i = 0;
      i < (kycImages.documents?.[documentIndex]?.length ?? 0);
      i += 2
    ) {
      documentImageRows.push(
        //@ts-expect-error
        kycImages.documents?.[documentIndex]?.slice(i, i + 2),
      );
    }
    return documentImageRows;
  };

  const getExtractedData = (
    extractedData: Record<string, string | Record<string, string>>,
  ) => {
    return Object.keys(extractedData).map((label) => {
      const value = extractedData[label];

      return {
        label: capitalize(label.replaceAll('_', ' ')),
        value:
          value && typeof value === 'object'
            ? Object.keys(value).map(
                (key) =>
                  `${capitalize(key.replaceAll('_', ' '))}: ${value[key]}`,
              )
            : value,
      };
    });
  };

  const getBreakdownLabel = (label: string) =>
    label === 'pep' ? 'PEP' : capitalize(label);

  const getBreakdownValues = (
    breakdown?: Array<{
      subCheck?: string;
      result?: string;
      details?: Array<{ name?: string; value?: string }>;
    }>,
  ) =>
    breakdown?.length
      ? breakdown?.map((data) => ({
          label: getBreakdownLabel(data.subCheck?.replaceAll('_', ' ') ?? ''),
          value: data.result,
          color: data.result === 'PASS' ? 'green' : 'red',
          icon: data.result === 'PASS' ? checkIcon : failIcon,
          details:
            data.details
              ?.filter((detail) => detail.name)
              .map((detail) => `${detail.name}: ${detail.value}`) ?? [],
        }))
      : null;

  const overviewValues = {
    'Session ID': sessionId,
    'User ID': investorId,
    Started: dateToLabel(createdAt, 'N/A', true),
    Status: capitalize(yotiStatus),
  };

  const getRecommendation = (
    checkResults?: Array<{ recommendation?: string }>,
  ) => {
    return (
      checkResults?.find((result) => !!result.recommendation)?.recommendation ??
      '-'
    );
  };

  const recommendationValues = [
    {
      image: userImage,
      name: 'Liveness capture',
      value: livenessCheck?.approved
        ? 'Approve'
        : getRecommendation(livenessCheck?.results ?? []),
      color: livenessCheck?.approved ? 'green' : 'orange',
      icon: livenessCheck?.approved ? checkIcon : warningIcon,
    },

    {
      image: idImage,
      name: 'Document authenticity',
      value: documentAuthenticityCheck?.approved
        ? 'Approve'
        : getRecommendation(documentAuthenticityCheck?.results ?? []),
      color: documentAuthenticityCheck?.approved ? 'green' : 'orange',
      icon: documentAuthenticityCheck?.approved ? checkIcon : warningIcon,
    },
    {
      image: faceImage,
      name: 'Face match',
      value: faceMatchCheck?.approved
        ? 'Approve'
        : getRecommendation(faceMatchCheck?.results ?? []),
      color: faceMatchCheck?.approved ? 'green' : 'orange',
      icon: faceMatchCheck?.approved ? checkIcon : warningIcon,
    },
    {
      image: nameImage,
      name: 'Name match',
      value: detailsMatch ? 'Approve' : 'Consider',
      color: detailsMatch ? 'green' : 'orange',
      icon: detailsMatch ? checkIcon : warningIcon,
    },
    {
      image: eyeImage,
      name: 'AML advanced screening',
      value: amlCheck?.approved
        ? 'Approve'
        : getRecommendation(amlCheck?.results),
      color: amlCheck?.approved ? 'green' : 'orange',
      icon: amlCheck?.approved ? checkIcon : warningIcon,
    },
  ];

  const getCheckDetailsTable = (
    check: CheckDetails | undefined,
    checkType: string,
  ) => [
    [
      { text: 'Check details', style: 'tableSubheader' },
      { text: 'Breakdown', style: 'tableSubheader' },
    ],
    ...(check?.results?.map((result) => [
      {
        columns: [
          {
            width: 95,
            style: 'checkDetails',
            stack: [
              { text: 'Type', bold: true },
              { text: 'Status', bold: true },
              { text: 'Recommendation', bold: true },
              { text: 'Reason', bold: true },
            ],
          },
          {
            style: 'checkDetails',
            stack: [
              checkType,
              result.status ?? '-',
              result.recommendation ?? '-',
              {
                text: result.reason?.replaceAll('_', ' ') ?? '-',
                style: 'reasonText',
              },
            ],
          },
        ],
      },
      {
        layout: 'noBorders',
        table: {
          widths: ['80%', '20%'],
          body: getBreakdownValues(result.breakdown ?? [])?.map((breakdown) => [
            [
              { text: breakdown.label, bold: true, margin: [0, 3, 0, 0] },
              ...(breakdown.details.map((details) => ({
                text: details,
                fontSize: 10,
              })) ?? []),
            ],
            [
              {
                alignment: 'right',
                columnGap: 4,
                columns: [
                  {
                    text: breakdown.value,
                    color: breakdown.color,
                    margin: [0, 3, 4, 0],
                  },
                  { width: 15, image: breakdown.icon },
                ],
              },
            ],
          ]) ?? [[], []],
        },
      },
    ]) ?? []),
  ];

  const pdfMake = await loadPdfMake();
  pdfMake
    .createPdf(
      {
        pageMargins: [40, 110, 40, 60],
        header: [
          {
            margin: [40, 30, 40, 20],
            stack: [
              {
                columns: [
                  {
                    width: 15,
                    image: checkImage,
                  },
                  { text: 'Identity Verification Session', style: 'header' },
                ],
                marginBottom: 15,
              },
              {
                marginLeft: 20,
                marginBottom: 5,
                columns: [
                  {
                    width: 100,
                    text: 'Organisation name:',
                    style: 'headerAppInfo',
                  },
                  { width: 'auto', text: 'Further', style: 'headerAppInfo' },
                ],
              },
              {
                marginLeft: 20,
                columns: [
                  {
                    width: 100,
                    text: 'Application name:',
                    style: 'headerAppInfo',
                  },
                  { width: 'auto', text: 'Further', style: 'headerAppInfo' },
                ],
              },
            ],
            columnGap: 6,
          },
        ],
        footer: (currentPage) => {
          return {
            columns: [
              `Session ID: ${sessionId}`,
              { text: `Page ${currentPage}`, alignment: 'right' },
            ],
            style: 'footer',
          };
        },
        pageBreakBefore: (currentNode) => {
          return (
            currentNode.id === 'livenessCapture' ||
            currentNode.id === 'livenessCaptureImages' ||
            currentNode.id === 'document' ||
            currentNode.id === 'amlCheck' ||
            currentNode.id === 'nameCheck' ||
            currentNode.id === 'documentExtraction'
          );
        },
        content: [
          {
            style: 'table',
            layout: 'greyBorders',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Overview',
                    style: 'tableHeader',
                  },
                ],
                ...Object.keys(overviewValues).map((key) => {
                  return [
                    {
                      stack: [
                        { text: key, style: 'overviewLabel' },
                        overviewValues[key],
                      ],
                    },
                  ];
                }),
              ],
            },
          },
          {
            style: 'table',
            layout: 'greyBorders',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Recommendations',
                    style: 'tableHeader',
                  },
                ],
                ...recommendationValues.map((value) => [
                  {
                    columns: [
                      {
                        width: 24,
                        image: value.image,
                      },
                      {
                        width: '*',
                        text: value.name,
                        margin: [25, 5, 0, 0],
                      },
                      {
                        width: 100,
                        margin: [0, 5, 0, 0],
                        text: value.value,
                        color: value.color,
                        alignment: 'right',
                      },
                      {
                        width: 16,
                        image: value.icon,
                        margin: [10, 3, 0, 0],
                      },
                    ],
                    margin: [0, 0, 10, 0],
                  },
                ]),
              ],
            },
          },
          {
            //@ts-expect-error
            id: 'livenessCapture',
            style: 'table',
            layout: 'greyBorders',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Liveness capture',
                    style: 'tableHeader',
                  },
                ],
                [
                  {
                    columns: [
                      {
                        width: 32,
                        image: userImage,
                      },
                      {
                        width: '*',
                        text: 'Liveness capture',
                        margin: [25, 9, 0, 0],
                      },
                      {
                        width: '*',
                        text: `${
                          kycImages.livenessCapture?.length ?? 0
                        } images collected`,
                        margin: [0, 9, 0, 0],
                      },
                    ],
                  },
                ],
              ],
            },
          },
          {
            style: 'table',
            layout: 'container',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Checks performed',
                    style: 'containerTableHeader',
                  },
                ],
                [
                  {
                    style: 'breakdownTable',
                    layout: 'greyBordersChild',
                    table: {
                      widths: ['50%', '50%'],
                      body: getCheckDetailsTable(
                        livenessCheck,
                        'Static liveness',
                      ),
                    },
                  },
                ],
              ],
            },
          },
          {
            //@ts-expect-error
            id: 'livenessCaptureImages',
            style: 'table',
            layout: 'greyBorders',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Liveness capture',
                    style: 'tableHeader',
                  },
                ],
                [
                  {
                    columns: [
                      {
                        width: 32,
                        image: userImage,
                      },
                      {
                        width: '*',
                        text: 'Liveness capture',
                        margin: [25, 9, 0, 0],
                      },
                      {
                        width: '*',
                        text: `${
                          kycImages.livenessCapture?.length ?? 0
                        } images collected`,
                        margin: [0, 9, 0, 0],
                      },
                    ],
                  },
                ],
              ],
            },
          },
          {
            style: 'table',
            layout: 'container',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Collected images',
                    style: 'containerTableHeader',
                  },
                ],
                ...livenessCaptureRows.map((row) => [
                  {
                    columns: row.map((image) => ({
                      width: 182,
                      stack: [
                        {
                          image: image?.content,
                          width: 150,
                        },
                      ],
                    })),
                  },
                ]),
              ],
            },
          },
          (documents ?? []).map((document, index) => [
            {
              id: 'document',
              style: 'table',
              layout: 'greyBorders',
              table: {
                widths: ['100%'],
                body: [
                  [
                    {
                      text: `ID document ${index + 1}`,
                      style: 'tableHeader',
                    },
                  ],
                  [
                    {
                      columns: [
                        {
                          width: 32,
                          image: idImage,
                          margin: [0, 12, 0, 0],
                        },
                        {
                          width: '35%',
                          margin: [25, 0, 0, 0],
                          style: 'checkHeaderDetailsLabels',
                          stack: [
                            'Document ID',
                            'Document type',
                            'Issuing authority',
                          ],
                        },
                        {
                          width: '*',
                          style: 'checkHeaderDetails',
                          stack: [
                            document.documentId,
                            document.documentType,
                            document.issuingCountry,
                          ],
                        },
                      ],
                    },
                  ],
                ],
              },
            },
            {
              style: 'table',
              layout: 'container',
              table: {
                widths: ['100%'],
                body: [
                  [
                    {
                      text: 'Checks performed',
                      style: 'containerTableHeader',
                    },
                  ],
                  [
                    {
                      style: 'breakdownTable',
                      layout: 'greyBordersChild',
                      table: {
                        widths: ['50%', '50%'],
                        body: getCheckDetailsTable(
                          documentAuthenticityCheck,
                          'Authenticity',
                        ),
                      },
                    },
                  ],
                  [
                    {
                      style: 'table',
                      layout: 'greyBordersChild',
                      table: {
                        widths: ['50%', '50%'],
                        body: getCheckDetailsTable(
                          faceMatchCheck,
                          'Face match',
                        ),
                      },
                    },
                  ],
                ],
              },
            },
            {
              id: 'documentExtraction',
              style: 'table',
              layout: 'container',
              table: {
                widths: ['100%'],
                body: [
                  [
                    {
                      text: 'Text extraction',
                      style: 'containerTableHeader',
                    },
                  ],
                  [
                    {
                      style: 'table',
                      layout: 'greyBordersChild',
                      table: {
                        widths: ['50%', '50%'],
                        body: document.extractedDocument
                          ? [
                              ...getExtractedData(
                                document.extractedDocument,
                              ).map((data) => [[data.label], [data.value]]),
                            ]
                          : [[], []],
                      },
                    },
                  ],
                ],
              },
            },

            {
              id: 'document',
              style: 'table',
              layout: 'greyBorders',
              table: {
                widths: ['100%'],
                body: [
                  [
                    {
                      text: `ID document ${index + 1}`,
                      style: 'tableHeader',
                    },
                  ],
                  [
                    {
                      columns: [
                        {
                          width: 32,
                          image: idImage,
                          margin: [0, 12, 0, 0],
                        },
                        {
                          width: '35%',
                          margin: [25, 0, 0, 0],
                          style: 'checkHeaderDetailsLabels',
                          stack: [
                            'Document ID',
                            'Document type',
                            'Issuing authority',
                          ],
                        },
                        {
                          width: '*',
                          style: 'checkHeaderDetails',
                          stack: [
                            document.documentId,
                            document.documentType,
                            document.issuingCountry,
                          ],
                        },
                      ],
                    },
                  ],
                ],
              },
            },
            {
              style: 'table',
              layout: 'container',
              table: {
                widths: ['100%'],
                body: [
                  [
                    {
                      text: 'Document media',
                      style: 'containerTableHeader',
                    },
                  ],
                  ...getDocumentImageRows(index).map((row) => [
                    {
                      columns: row.map((image) => ({
                        width: 270,
                        stack: [
                          {
                            image: image?.content,
                            width: 220,
                          },
                        ],
                      })),
                    },
                  ]),
                ],
              },
            },
          ]),

          {
            //@ts-expect-error
            id: 'nameCheck',
            style: 'table',
            layout: 'greyBorders',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Name check',
                    style: 'tableHeader',
                  },
                ],
                [
                  {
                    columns: [
                      {
                        width: 32,
                        image: nameImage,
                      },
                      {
                        width: '*',
                        text: 'Name check',
                        margin: [25, 10, 0, 0],
                      },
                      {
                        width: '*',
                        text: `${documents?.length ?? 0} document(s) checked`,
                        margin: [0, 10, 0, 0],
                      },
                    ],
                  },
                ],
              ],
            },
          },
          {
            style: 'table',
            layout: 'container',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Checks performed',
                    style: 'containerTableHeader',
                  },
                ],
                [
                  {
                    style: 'breakdownTable',
                    layout: 'greyBordersChild',
                    table: {
                      widths: ['50%', '50%'],
                      body: getCheckDetailsTable(
                        {
                          approved: detailsMatch,
                          results: [
                            {
                              status: 'DONE',
                              recommendation: detailsMatch
                                ? 'Approve'
                                : 'Consider',
                              reason: detailsMatch
                                ? ''
                                : "The name on the user's Further account is not an exact match with the provided identity document.",
                            },
                          ],
                        },
                        'Name check',
                      ),
                    },
                  },
                ],
              ],
            },
          },
          {
            //@ts-expect-error
            id: 'amlCheck',
            style: 'table',
            layout: 'greyBorders',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'AML advanced screening',
                    style: 'tableHeader',
                  },
                ],
                [
                  {
                    columns: [
                      {
                        width: 32,
                        image: eyeImage,
                        margin: [0, 15, 0, 0],
                      },
                      {
                        width: '*',
                        style: 'checkHeaderDetailsLabels',
                        stack: [
                          'Total matches',
                          'Associated country codes',
                          'Client reference',
                          'Search type',
                        ],
                        margin: [25, 0, 0, 0],
                      },
                      {
                        width: '*',
                        style: 'checkHeaderDetails',
                        stack: [
                          getWatchlistSummary(amlCheck?.results ?? [])
                            ?.totalHits ?? '-',
                          getWatchlistSummary(
                            amlCheck?.results ?? [],
                          )?.associatedCountryCodes?.join(', ') ?? '-',
                          getWatchlistSummary(amlCheck?.results ?? [])
                            ?.searchConfig?.clientRef ?? '-',
                          capitalize(
                            getWatchlistSummary(
                              amlCheck?.results ?? [],
                            )?.searchConfig?.sources?.type?.replaceAll(
                              '_',
                              ' ',
                            ) ?? '-',
                          ),
                        ],
                      },
                    ],
                  },
                ],
              ],
            },
          },
          {
            style: 'table',
            layout: 'container',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Checks performed',
                    style: 'containerTableHeader',
                  },
                ],
                [
                  {
                    style: 'breakdownTable',
                    layout: 'greyBordersChild',
                    table: {
                      widths: ['50%', '50%'],
                      body: getCheckDetailsTable(
                        amlCheck,
                        'AML advanced screening',
                      ),
                    },
                  },
                ],
              ],
            },
          },
          ...(amlCheck?.results?.map((result) => ({
            style: 'table',
            layout: 'container',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Advanced search',
                    style: 'containerTableHeader',
                  },
                ],
                ...(Array.isArray(result.watchlistSummary?.rawResults)
                  ? result.watchlistSummary.rawResults.map((rawResult) => [
                      {
                        style: 'table',
                        layout: 'greyBordersChild',
                        table: {
                          widths: ['50%', '50%'],
                          body: [
                            [['Provider'], [rawResult?.provider ?? '-']],
                            [
                              ['URL'],
                              [
                                {
                                  text: rawResult?.url ?? '-',
                                  link: rawResult?.url ?? '-',
                                },
                              ],
                            ],
                          ],
                        },
                      },
                    ])
                  : []),
              ],
            },
          })) ?? []),
        ],
        styles: {
          headerAppInfo: {
            color: '#495566',
            fontSize: 10,
            bold: true,
          },
          footer: {
            color: '#495566',
            fontSize: 10,
            margin: [40, 15, 40, 15],
          },
          table: {
            marginBottom: 15,
            fontSize: 11,
            color: '#495566',
          },
          breakdownTable: {
            fontSize: 11,
            color: '#495566',
          },
          tableHeader: {
            bold: true,
            fontSize: 14,
            color: '#333333',
            fillColor: '#ABB5C0',
            margin: [0, 4, 0, 4],
          },
          containerTableHeader: {
            bold: true,
            fontSize: 14,
            color: '#333333',
            fillColor: '#ABB5C0',
            margin: [16, 4, 16, 4],
          },
          tableSubheader: {
            bold: true,
            fontSize: 13,
            color: '#333333',
          },
          overviewLabel: {
            color: '#495566',
            bold: true,
            marginBottom: 4,
          },
          checkDetails: {
            lineHeight: 1.6,
          },
          checkHeaderDetailsLabels: {
            bold: true,
            lineHeight: 1.4,
          },
          checkHeaderDetails: {
            lineHeight: 1.4,
          },

          header: {
            fontSize: 16,
            bold: true,
          },
          bold: {
            color: '#495566',
            bold: true,
          },
          reasonText: {
            lineHeight: 1,
          },
        },
      },
      {
        greyBorders: {
          hLineColor: () => {
            return '#ABB5C0';
          },
          vLineColor: () => {
            return '#ABB5C0';
          },
          paddingLeft: () => 16,
          paddingRight: () => 16,
          paddingTop: (i) => {
            return i === 0 ? 0 : 8;
          },
          paddingBottom: (i) => {
            return i === 0 ? 0 : 8;
          },
        },
        greyBordersChild: {
          hLineColor: () => {
            return '#ABB5C0';
          },
          vLineColor: () => {
            return '#ABB5C0';
          },
          paddingLeft: () => 16,
          paddingRight: () => 16,
          paddingTop: () => 8,
          paddingBottom: () => 8,
        },
        container: {
          hLineWidth: () => 0,
          vLineWidth: () => 0,
          paddingLeft: () => 0,
          paddingRight: () => 0,
          paddingTop: () => 0,
          paddingBottom: () => 0,
        },
      },
    )
    .download(
      `Further Finance Ltd-${investorDetail?.fullName?.toLowerCase()}-KYC record-${sessionId}`,
    );
};

export default downloadKycPdf;
